import $ from 'jquery';

export default class MenuTrigger{
    constructor() {
        this.menu_items = $('.menu-item-has-children');
    }
    init (){
        this.menu_items.on('click', function (e){
            e.stopPropagation();
            $(this).toggleClass('open--link');
            $(this).children('.sub-menu').slideToggle();
        });
    }
}

